import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-journal-mgt',
  templateUrl: './journal-mgt.component.html',
  styleUrls: ['./journal-mgt.component.css']
})
export class JournalMgtComponent implements OnInit {
  searchForm: FormGroup | any;
  // whichmodal: string = 'enable';
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  helplineId: any
  JournalList: any = [];
  faqId: any;
  constructor(private router: Router,
    public mainService: MainService) { }
  ngOnInit() {
    this.searchFormValidation();
    this.getJournalList()
  }

  searchFormValidation() {
    this.searchForm = new FormGroup({
      search: new FormControl('')
    });
  }



  pagination(event: any) {
    this.currentPage = event;
    this.getJournalList()
  }

  // ------- get helpline number list -------- //

  getJournalList() {

    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.journalQuestion_list, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.JournalList = res.result ? res.result : '';
        this.total = res.result.total;
        this.mainService.hideSpinner();
      } else {
        this.JournalList = res.result ? res.result : ''
        this.mainService.hideSpinner();
      }
    })
  }


  viewUser(id: any) {
    this.router.navigate(['view-journal/' + id])
  }
  editFaq(id: any) {
    this.router.navigate(['/edit-journal/' + id])

  }
  deleteFaqModal(id: any) {
    this.faqId = id
    $('#delete').modal('show')
  }

  deleteFaq() {
    const data = {}
    this.mainService.showSpinner();
    this.mainService.deleteApi(ApiUrls.deleteFaq + `?faqId=${this.faqId}`, data, 1).subscribe((res: any) => {
      $('#delete').modal('hide');
      this.mainService.hideSpinner();
      if (res.responseCode == 200) {
        this.JournalList = res.result;
        this.getJournalList()
        this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

}
